import type { CursorPacket } from "@livcg/schema";

export type RemoteCursor = CursorPacket & { at: number };

export const STALE_MS = 10000;

/** Kept outside React state: cursor packets arrive up to 20/s per operator and must not re-render MatchDay. */
export function createCursorStore() {
  const cursors = new Map<string, RemoteCursor>();
  const listeners = new Set<() => void>();
  let snap: RemoteCursor[] = [];
  const emit = () => {
    snap = [...cursors.values()];
    for (const l of listeners) l();
  };
  return {
    subscribe(l: () => void) {
      listeners.add(l);
      return () => {
        listeners.delete(l);
      };
    },
    snapshot: () => snap,
    set(c: CursorPacket) {
      const now = Date.now();
      for (const [id, v] of cursors) if (now - v.at > STALE_MS) cursors.delete(id);
      if (c.anchor === null) cursors.delete(c.id);
      else cursors.set(c.id, { ...c, at: now });
      emit();
    },
    retain(ids: Set<string>) {
      let changed = false;
      for (const id of cursors.keys())
        if (!ids.has(id)) {
          cursors.delete(id);
          changed = true;
        }
      if (changed) emit();
    },
    clear() {
      if (cursors.size === 0) return;
      cursors.clear();
      emit();
    },
  };
}

export type CursorStore = ReturnType<typeof createCursorStore>;
